import type { UnitInfoMobileVSIInterface } from 'store/units/types';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { MobileVSIUnitInfoDataInterface } from './unitInfoData';

export class MobileVSIConfig extends BaseUnitConfig {
  static getDefaultData(params?: UnitConfigParams): UnitInfoMobileVSIInterface {
    const unitInfoData =
      (params?.data as MobileVSIUnitInfoDataInterface | undefined) ?? {};
    const defaultModel = Object.entries(unitInfoData)[1];
    const model = defaultModel[0];
    const modelData = defaultModel[1];

    const vsiData = modelData.configurations.VSI1.model['CV217'];
    const screen1Data = unitInfoData[model].configurations.CONVENTIONAL_SCREEN1;

    const flexModel = Object.entries(unitInfoData)[3];
    const flexModelData = flexModel[1];

    const screen2Data = flexModelData.configurations.SCREEN2;
    const splitData = modelData.configurations.SPLIT1;
    const freeFallScreenData = flexModelData.configurations.FREEFALL_SCREEN1;

    return {
      ...BaseUnitConfig.getBaseDefaults(),
      modelName: model,
      configuration: modelData.configurations.configurationOptions[0],
      numberOfPorts: 3,
      moisture: 0,
      newMoisture: false,
      VSI1: {
        modelName: vsiData.simulationModel,
        motorFrequency: vsiData.defaultMotorFrequency,
        motorPower: vsiData.defaultMotorPower,
        tipSpeed: vsiData.defaultTipSpeed,
        materialShape: {
          name: vsiData.defaultMaterial,
          value: vsiData.defaultMaterial.toUpperCase(),
        },
      },
      SCREEN1: {
        screenModel: screen1Data.model.simulationModel,
        decks: {
          0: {
            separationSize: screen1Data.decks[0].defaultSeparationSize,
          },
          1: {
            separationSize: screen1Data.decks[1].defaultSeparationSize,
          },
          2: {
            separationSize: screen1Data.decks[2].defaultSeparationSize,
          },
          3: {
            separationSize: 2,
          },
        },
      },
      SCREEN2: {
        decks: {
          0: { separationSize: screen2Data.decks[0].defaultSeparationSize },
          1: { separationSize: screen2Data.decks[1].defaultSeparationSize },
        },
      },
      SPLIT1: {
        returnToCrusher: splitData.defaultAmountRight,
        directToCrusher: 100,
      },
      FREEFALL_SCREEN1: {
        modelName:
          flexModelData.configurations.FREEFALL_SCREEN1.model.simulationModel,
        decks: {
          0: {
            separationSize: freeFallScreenData.decks[0].defaultSeparationSize,
          },
          1: {
            separationSize: freeFallScreenData.decks[1].defaultSeparationSize,
          },
          2: {
            separationSize: freeFallScreenData.decks[2].defaultSeparationSize,
          },
        },
      },
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayConfig: false,
        displayLoad: true,
        displayCrusherModel: false,
        displayCrusherTipSpeed: false,
        displayFeederModel: false,
        displayNFScreenModel: false,
        displayFeederSeparation: false,
        displayGrizzlySeparation: false,
        displayScreenModel: false,
        displayScreenSeparation: false,
      },
      parallelUnits: 1,
    };
  }

  static getNumberOfPorts(_model?: string, _config?: number): number {
    return 4;
  }
}

export const mobileVSIConfig = new MobileVSIConfig();

export const getNumberOfPorts = (model: string, configKey: number) => {
  const isKey = (...keys: number[]) => keys.includes(configKey);
  switch (model) {
    case 'UV210':
      if (isKey(1, 3)) {
        return 2;
      }
      return 3;
    case 'UV312':
      if (isKey(1, 3, 5, 7)) {
        return 3;
      } else if (isKey(2, 6)) {
        return 2;
      }
      return 4;
    case 'UV320E_FLEX':
      if (isKey(3)) {
        return 3;
      } else if (isKey(1, 2)) {
        return 4;
      }
      return 5;

    default:
      if (isKey(3, 5)) {
        return 2;
      } else if (isKey(1, 2, 4)) {
        return 3;
      }
      return 4;
  }
};
